/**
 * Adds a "Change Password" entry to the Volto toolbar user menu.
 *
 * Volto's PersonalTools.jsx exposes Profile, Preferences, Site Setup but not
 * Change Password.  /change-password route exists and works, it just has no
 * menu link.  We inject one via the `toolbar-user-menu` pluggable.
 *
 * DR-2026-091 (original, vilax). DR-2026-210: relocated here into the shared
 * volto-nick-compat addon so every converged tenant's editor toolbar gains the
 * link (previously vilax-only).
 */
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Plug } from '@plone/volto/components/manage/Pluggable';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import rightArrowSVG from '@plone/volto/icons/right-key.svg';

const ChangePasswordPlug = () => (
  <Plug pluggable="toolbar-user-menu" id="change-password">
    <li>
      <Link to="/change-password">
        <FormattedMessage
          id="Change Password"
          defaultMessage="Change Password"
        />
        <Icon name={rightArrowSVG} size="24px" />
      </Link>
    </li>
  </Plug>
);

export default ChangePasswordPlug;
